var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hotel_svg__a",
    d: "M35.28 1.429H.72v-.73h34.56z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.514 36.626H16.29V20.4c0-1.183.966-2.143 2.16-2.143h12.905c1.194 0 2.16.96 2.16 2.143v16.225z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.009 35.911h15.785v-15.51c0-.787-.645-1.428-1.44-1.428H18.449c-.794 0-1.44.641-1.44 1.428v15.51zm17.225 1.429H15.569V20.4c0-1.575 1.291-2.857 2.88-2.857h12.905c1.588 0 2.88 1.282 2.88 2.857V37.34z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.98 26.58h-8.862a.717.717 0 01-.72-.714c0-.394.32-.714.72-.714h8.861c.398 0 .72.32.72.714a.717.717 0 01-.72.714M28.98 30.943h-8.862a.717.717 0 01-.72-.714c0-.394.32-.714.72-.714h8.861c.398 0 .72.32.72.714a.717.717 0 01-.72.714",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.902 36.626H7.677V11.857a2.15 2.15 0 012.16-2.143h12.905c1.192 0 2.16.959 2.16 2.143v24.769z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.396 35.911h15.785V11.857c0-.787-.645-1.429-1.44-1.429H9.836c-.793 0-1.44.642-1.44 1.429v24.054zm17.225 1.429H6.956V11.857C6.956 10.281 8.248 9 9.836 9h12.905c1.589 0 2.88 1.281 2.88 2.857V37.34z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.595 35.911)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hotel_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hotel_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#hotel_svg__b)",
    d: "M.72.698h34.56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.875 37.324H3.315a.717.717 0 01-.72-.714c0-.395.323-.715.72-.715h34.56c.398 0 .72.32.72.715a.717.717 0 01-.72.714",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.73 36.61h-5.296v-5.75c0-.789.645-1.429 1.44-1.429h2.417c.794 0 1.44.64 1.44 1.429v5.75z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.155 35.895h3.856V30.86a.717.717 0 00-.72-.715h-2.416c-.398 0-.72.32-.72.715v5.035zm5.296 1.429h-6.736V30.86c0-1.182.969-2.143 2.16-2.143h2.416c1.19 0 2.16.961 2.16 2.143v6.464zM20.72 17.27h-8.862a.717.717 0 01-.72-.714c0-.394.321-.714.72-.714h8.862c.397 0 .72.32.72.714a.717.717 0 01-.72.714M20.72 21.14h-8.862a.717.717 0 01-.72-.714c0-.394.321-.714.72-.714h8.862c.397 0 .72.32.72.714a.717.717 0 01-.72.714M20.72 25.01h-8.862a.717.717 0 01-.72-.715c0-.394.321-.714.72-.714h8.862c.397 0 .72.32.72.714a.717.717 0 01-.72.714",
    fill: "#000"
  }))));
}
export default SvgHotel;